<template>
    <div>
        <div class="card">
            <div class="card-header">
                <h4 class="card-title w-100 d-flex align-items-center justify-content-between">
                    <span class="text-app">Untested Forms</span>
                    <div class="ml-auto">
                        <button class="btn btn-sm btn-default border" :disabled="!canAddRows" @click.prevent="addRow()">
                            <i class="fa fa-plus mr-2"></i> Add Row
                        </button>
                        <button class="btn btn-sm btn-success ml-2" :disabled="canSaveChanges" @click.prevent="submit()">
                            <i class="fa fa-save mr-2"></i>Save Changes
                        </button>
                    </div>
                </h4>
            </div>
            <div class="card-body p-0">
                <div class="table-responsive">
                    <table class="table mb-0 table-sm">
                        <thead>
                        <tr style="background: #efefef">
                            <th class="text-center">#</th>
                            <th style="color: #333;">Building</th>
                            <th style="color: #333">Floor</th>
                            <th style="color: #333">Space</th>
                            <th class="text-center" v-if="!project.is_completed"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(untestedForm, index) in form.untested_forms" :key="`untested-row-${index}`">
                            <td class="text-center" v-text="(index + 1)"></td>
                            <td>
                                <input type="text"
                                       class="form-control form-control-sm"
                                       :disabled="disabledInputs"
                                       :class="{'border-danger' : form.errors.has('untested_forms.' + index + '.building')}"
                                       v-model="form.untested_forms[index].building">
                            </td>
                            <td>
                                <input type="text"
                                       class="form-control form-control-sm"
                                       :disabled="disabledInputs"
                                       :class="{'border-danger' : form.errors.has('untested_forms.' + index + '.floor')}"
                                       v-model="form.untested_forms[index].floor">
                            </td>
                            <td>
                                <input type="text"
                                       class="form-control form-control-sm"
                                       :disabled="disabledInputs"
                                       :class="{'border-danger' : form.errors.has('untested_forms.' + index + '.space')}"
                                       v-model="form.untested_forms[index].space">
                            </td>
                            <td class="text-center" v-if="!project.is_completed">
                                <button type="button" @click="removeRow(index)" class="btn btn-default btn-sm ml-2 d-flex align-items-center justify-content-center" style="width: 25px; height: 15px;">
                                    <i class="fa fa-times text-danger m-0"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="form.untested_forms.length == 0">
                            <td class="text-center bg-white" colspan="5">
                                <div class="p-4">
                                    <p class="text-muted">There are not untested records for this form.</p>
                                    <button :disabled="form.id == null" type="button" @click="addRow" class="btn btn-sm btn-success">Add Untested Form</button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>

        <div class="alert alert-danger" v-if="form.untested_forms.length == test.form.untested_areas">
            You have added <span class="font-weight-bold" v-text="test.form.untested_areas"></span> untested space forms, which is the maximun number you can add for the <span class="font-weight-bold" v-text="test.form.name"></span> form.
        </div>

    </div>
</template>
<script>
export default {

    props: ['project', 'test', 'space'],

    data() {
        return {
            form: new Form({
                id: this.test.id,
                space_id: this.space.id,
                untested_forms: this.test.untested_forms,
            }).dontClear()
        }
    },

    methods: {

        submit(){
            this.form.patch(`/projects/${this.project.slug}/sample-untested-forms`)
                .then(response => {
                    Toast.success('Changes saved successful.')
                })
                .catch(error => {
                    Toast.error(this.form.errors.first())
                })
        },

        addRow() {

            let data = {
                id: null,
                building: this.form.untested_forms.length ? this.form.untested_forms[this.form.untested_forms.length - 1].building : '',
                floor: this.form.untested_forms.length ? this.form.untested_forms[this.form.untested_forms.length - 1].floor : '',
                space: '',
            }

            if (this.isMultiZoneOccuantSensor) {
                data = {
                    id: null,
                    building: this.space.building,
                    floor: this.space.floor,
                    space: this.space.name,
                }
            }

            // Insert a new row with the same values as the last row inserted
            this.form.untested_forms.push(data)
        },

        removeRow(index){
            this.form.untested_forms.splice(index, 1)
        }
    },

    computed:{
        disabledInputs(){
            // The Automatic Shut-Off Multi-Zone form only allows untested forms on the same space area
            if(this.isMultiZoneOccuantSensor){
                return true;
            }

            if(this.project.is_completed){
                return true;
            }

            return false;
        },

        // ID 43 Is the "Automatic Shut-Off Multi-Zone Occupant Sensing Lighting Controls"
        isMultiZoneOccuantSensor() {

            if (this.test.hasOwnProperty('form')) {
                return this.test.form.id == 43;
            }

            return false;
        },

        canAddRows(){
            if(this.project.is_completed){
                return false
            }

            return this.test.form.untested_areas > this.form.untested_forms.length;
        },

        canSaveChanges(){
            if(this.project.is_completed){
                return true
            }

            return this.form.untested_forms.length == 0;
        }
    }
}
</script>
